import { http } from "helpers/Http";
import { ICompositionItemObject } from "types/Product";
import { IManyShoppingBagResponse, IShoppingBagData, ISingleShoppingBagResponse } from "types/ShoppingBag";
import { IPartialSumParams } from "types/UserOrder";
import logger from "components/Logger";

const path = 'services/api/requests/UserOrders/index.ts'

// params.id = 
// params.place_id = placeId
/* params.status {
    2 = preparing
    3 = cancelled ( "cancellation_reason": string)
    5 = done
    6 = waiting withdraw
    7 = on the way
    9 = finished   
    12 = manda pra o ElloRestaurante
    13 = cancelado
}*/

export async function postUpdateUserOrderStatus(params: IShoppingBagData): Promise<ISingleShoppingBagResponse> {
    const url = `usersorders/update/${params.id}`;
    const data = http.post(url, params).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postUpdateUserOrderStatus`)
    logger.log("| url: ", url)
    logger.log("| ORDER DETAILS: ", params)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

export async function postCancelUserOrder(params: IShoppingBagData): Promise<ISingleShoppingBagResponse> {
    const url = `usersorders/update/${params.id}`;
    const data = http.post(url, params).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postCancelUserOrder`)
    logger.log("| url: ", url)
    logger.log("| ORDER DETAILS: ", params)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

export async function fetchAPIUserOrdersFinished(user_id: number): Promise<IManyShoppingBagResponse> {
    const url = `usersorders?user_id=${user_id}&filter=finished&limit=10`;
    const data = http.get(url).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: fetchAPIUserOrdersFinished`)
    logger.log("| url: ", url)
    logger.log("| user_id: ", user_id)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

export async function fetchAPIUserOrdersPending(user_id: number): Promise<IManyShoppingBagResponse> {
    const url = `usersorders?user_id=${user_id}&filter=pending&limit=10`;
    const data = http.get(url).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: fetchAPIUserOrdersPending`)
    logger.log("| url: ", url)
    logger.log("| user_id: ", user_id)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

export async function postUpdateCompositeItem(params: ICompositionItemObject): Promise<IManyShoppingBagResponse> {
    const url = `usersorders/update/items/composition/${params.id}`;
    const data = http.post(url, params).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: postUpdateCompositeItem`)
    logger.log("| url: ", url)
    logger.log("| ICompositionItemObject: ", params)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}

export async function fetchAPIPartialSum(params: IPartialSumParams): Promise<IManyShoppingBagResponse> {
    const url = `usersorders/partial/${params.user_id}?data=${params.data}&time=${params.time}&place_id=${params.place_id}`;
    const data = http.get(url).then((response) => response.data);

    logger.log("************************************************************************************")
    logger.log(`| FILE: ${path} | METHOD: fetchAPIPartialSum`)
    logger.log("| url: ", url)
    logger.log("| IPartialSumParams: ", params)
    logger.log("| promise returned ", data)
    logger.log("************************************************************************************")

    return data;
}